import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Flag from '../Flag';

const bem = new BEMHelper('FlagWithCountry');

const propTypes = {
    country: PropTypes.string.isRequired,
    currencySymbol: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    countryName: PropTypes.string.isRequired,
    handleClick: PropTypes.func,
    className: PropTypes.string,
    prefixText: PropTypes.string,
};

const FlagWithCountry = ({ className, country, countryName, handleClick, prefixText }) => (
    <div className={bem(null, null, className)}>
        {prefixText && <span>{prefixText}</span>}
        <Flag className={bem('flag')} countryISO={country} />
        <span className={bem('country')} onClick={handleClick}>
            {countryName}
        </span>
    </div>
);

FlagWithCountry.propTypes = propTypes;

export default FlagWithCountry;
